<template>
    <div id="CreateArticles">
        <div class="header">
            <div class="title">
                <IconButton :on-click="() => $emit('close')">
                    <i class="material-icons">arrow_back_ios</i>
                </IconButton>
                {{ $t("message.createArticles") }}
            </div>
            <div class="description">{{ $t("message.createArticlesDesc") }}</div>
        </div>
        <div class="content">
            <div>{{ $t("message.articlesTitle") }}</div>
            <input
                v-model="title"
                type="text" />
            <div>{{ $t("message.articlesContent") }}</div>
            <textarea
                v-model="content"
            ></textarea>
            <div class="btn-container">
                <SupsisButton primary class="sup-btn" @click="saveArticle">
                    <i class="material-icons">save</i>
                    <span>{{ $t("message.save") }}</span>
                </SupsisButton>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import IconButton from "../../../Settings/components/IconButton.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "CreateArticles",
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
    components: {
        IconButton,
        SupsisButton,
    },
    data() {
        return {
            title: "",
            content: "",
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {

        ...mapActions({}),
        async saveArticle() {
            this.$emit("save", {
                title: this.title,
                content: this.content,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#CreateArticles {
    margin: 30px;

    .header {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .title {
            display: flex;
            gap: 10px;
            color: #22272d;
            font-size: 28px;
            font-weight: 700;
        }

        .description {
            color: #22272d;
            font-size: 18px;
            line-height: 23px;
            margin-top: 8px;
            margin-bottom: 10px;
        }

    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    .content div {
        font-size: 18px;
        font-weight: bold;
        color: #333;
    }

    .content input[type="text"], .content textarea {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 16px;
        width: 100%;
    }

    .content textarea {
        height: 400px;
        resize: vertical;
    }

    .sup-btn {
        float: right;
        color: white !important;
    }
}
</style>
